<div class="doughnut-view" [ngClass]="customClass">
    <canvas [id]="doughnutId" class="doughnut-card" [style.height.px]="height" [style.width.px]="width"></canvas>
    <div [id]="legendId" class="doughnut-respon" style="width: fit-content;"></div>
</div>